export default {
  line: "Сызық",
  language: "Тіл",
  common: [
    "Онлайн қызметтер",
    "Тоқтатуды болдырмау",

    "Сатып алу үшін 10 000 ₽ жұмсау керек пе!"
  ],
  informationHub: "SGM.s ресми хаб",
  charitables: [//慈善
    "SGM.s ресми ақпараттық орталығына қош келдіңіз! 🌟 Ашық және беделді ақпаратқа арналған платформаңыз. Мұнда сіз біздің ресми сертификаттау сертификаттарымызды 📜 тексере аласыз, толық ақпарат алу үшін https://sgm.lol/ сайтына кіре аласыз 🌐 және соңғы жаңартулар үшін Telegram арнамызға жазыла аласыз! 📲 Сонымен қатар, сіз Yahoo, The Associated Press және Google сияқты халықаралық БАҚ-тардан SGM.s туралы оң пікірлерді таба аласыз! 📰 Мұның бәрі SGM.s брендіне және оның болашақ дамуына деген сеніміңізді айтарлықтай арттырады, сізге ортақ мобильділік бизнесінде табысқа жетуге және үнемі айтарлықтай қосымша табыс табуға көмектеседі!💰🚀"
  ],
  details: [
    "Тапсырма бірлігінің бағасы",
    "Тапсырыс саны",
    "Күнделікті табыс",
    "деңгей",

    "Күнделікті пайда",

    "Депозит",

    "Депозитті қайтару күні",

    "қалған күндер",

    "Менің SGM.s деңгейім"
  ],
  upload: [
    "Жүктелуде...",
    "Қате пішім",

    "Сәтті жүктелді",

    "Жүктеу сәтсіз аяқталды"
  ],
  vanPull: [
    "Дерек жоқ",
    "Дерек жоқ"
  ],
  login: {
    title: 'Пайдаланушы аты мен құпия сөзбен кіріңіз',
    title_txt: 'Тіркелген ұялы телефон нөміріңізді пайдаланып кіріңіз',
    text: [
      "Пайдаланушы атын/құпия сөзді есте сақтау",
      "Жүйеге кіру...",

      "Қазір кіру"
    ],
    placeholder: [
      "Телефон нөмірін енгізіңіз",
      "Кіру құпия сөзін енгізіңіз"
    ],
    i18n: [
      "{title} тіркелгісі жоқ па? {a} {line}",
      "Тіркелу"
    ],
    serve:[
      "Біздің «құпиялылық саясатымызбен» немесе «сервер шарттарымен» келісіңіз"
    ]
  },
  register: {
    text: [
      "Тіркелуге қош келдіңіз",
      "SMS код жіберілуде...",

      "SMS кодын алу",
      "Тіркелуде...",

      "Қазір тіркелу",
      "Тіркелгіңіз бар ма? Қазір кіріңіз",
      "Ұялы телефон нөмірін тіркеу",
      "Электрондық поштаны тіркеу",
      "Кіруге оралу",
      "Тіркелмеген телефон нөмірі мен электрондық пошта мекенжайын пайдаланыңыз"
    ],
    placeholder: [
      "Телефон нөміріңізді енгізіңіз",
      "SMS растау кодын енгізіңіз",

      "Кіру құпия сөзін енгізіңіз",

      "Құпия сөзіңізді растаңыз",

      "Шақыру кодын енгізіңіз",

      "Екі құпия сөз әртүрлі",

      "Растау кодын енгізіңіз",

      "Электрондық пошта нөмірін енгізіңіз",

      "0-ден бастау мүмкін емес"
    ],
    i18n: [
      "Тіркелгіңіз бар ма? {a} {line}",
      "Кіру"
    ]
  },
  home: {
    lucky: "Іс-шара әлі ашық емес",
    map: "Орналасқан жері",
    qywh: "Корпоративтік мәдениет",
    broadcast: "Досыңызды SGM.s онлайн велосипед алмасу бағдарламасына шақырғаны, {vipname} қызметіне көтерілгені және {grade} бөлісу сыйақыларын алғаны үшін {member} құттықтаймыз.",
    menu: [
      "VIP аймағы",
      "Бейне оқулық",

      "Жарнамалық марапаттар"
    ],
    taskHall: {
      title: [
        "Тапсырмалар залы",
        "Бизнес залы",
        "Пайда табу үшін тапсырмаларды орындаңыз"
      ]
    },
    title: ['Тапсырма', 'Жаңалықтар', 'көбірек', 'құлпын ашу', 'Құлпын ашып, пайдалануды жалғастырыңыз~', 'Тексеру', 'Құттықтаймыз!Жаңарту сәтті өтті', 'Құттықтаймыз~ екі карта алдым'],
    memberList: {
      title: "Мүшелік тізімі",
      data: [
        "{member}, бүгінгі {num} тапсырыс тапсырмаларын орындаңыз!"
      ]
    },
    businessList: {
      title: "Саудагерлер тізімі",
      data: [
        "{member}",
        "Бүгін {num} бір тапсырманы босатыңыз"
      ]
    },
    noticeTitle: ["Ескерту", "Алдыңғы", "Келесі"],
    tabBar: ["Үй", "Жеткізу", "T", "Карта", "Менің"],
    msg: "Тапсырма ашық емес",
    video: "Бейне оқулық жоқ",
    message: "Сізде жаңа жаңалықтар бар",
    bonus: [
      '<p>«Велосипед коды» ақшалай сыйлығын алу үшін кодты енгізіңіз (1-200000 TJS)</p><p>1. «Велосипед коды» компанияның қызметі арқылы алынады!</p><p>2. SGM.s будзе перыядычна публікаваць пароль! Калі ласка, правярайце наяўнасць абнаўленняў штодня!</p><p>Велосипедтерді пайдаланыңыз, ортақ пайдалану экономикасының өмірінен ләззат алыңыз және код бойынша ақшалай сыйақыларды оңай алыңыз!</p><p>Толығырақ ақпарат алу үшін «Нарық менеджері» хабарласыңыз</p>',
      'Құпия сөз компанияның қызметі арқылы алынады!',
      'Қызыл конверт кодын енгізіңіз',
      'Қолма-қол ақша алыңыз',
      'Ride Cash {amount}TJS ұтып алуыңызбен құттықтаймыз',
      'Ride Cash'
    ]
  },
  vip: {
    title: [
      "VIP деңгейі",
      "Тапсырмаларды алу үшін қазір мүшелікке қосылыңыз",

      "Әзірлену үстінде"
    ],
    user: {
      title: [
        "Сіздің жеке басыңыз",
        "Қонақтар"
      ],
      label: "Күнделікті тапсырмалар",
      value: [
        "Күшіне ену күні",
        "Бір жыл",

        "Алдымен жүйеге кіріңіз",

        "Тағылымдама мерзімі",

        "Депозитті қайтарудың кері санағы",

        "VIP деңгейінің жарамдылық мерзімінің кері санағы"
      ],
    },
    list: {
      label: "Күнделікті тапсырыс:{number}",
      button: "Қазір қосылыңыз",
      text: [
        "Күнделікті пайда",
        "Ай сайынғы табыс",

        "жұмысқа қабылдау сыйақысы: Барлығы",

        "Тегін",

        "Әрбір тапсырыс үшін",

        "Рейтингтік табыс",

        "Тиімді кірістер",

        "Мерзімі біту күні",

        "Жыл",

        "Күн",

        "Жарамдылық мерзімі"
      ],
    },
    dialog: [
      "Сіз {name} болу үшін {current} {amount} жұмсайтыныңызға сенімдісіз бе?",
      "Сіз қазіргі уақытта {currname} болып табыласыз және {name} бола алмайсыз",
      "Сіз {name} жаңарту үшін {current} {amount} жұмсайтыныңызға сенімдісіз бе?",
    ],
    index: ["Cancel", "Confirm"],
    desc: [
      '{level} жеңілдіктері',
      'Негізгі табыс',
      'Уақыт',
      'Жеткізу саны',
      'Табыс',

      'Күнделікті',
      'Айлық',

      'Жылдық',

      'Жұмысқа қабылдаудан түскен табыс',//8
      'Бағынышты деңгей',
      'Жұмысқа қабылдау комиссиясының коэффициенті',
      'Жұмысқа қабылдау бонусы',
      '1-деңгейлі бағынышты',
      '2-деңгейлі бағынышты',

      '3-деңгейлі бағынышты',
      'Бір күндік жеткізу жеңілдігі',
      'Бағынышты деңгей',

      'Бағынышты жеткізу жеңілдігінің коэффициенті',//17
      'Жеткізу жеңілдігінің сомасы',
      '1-деңгейлі бағынышты',
      '2-деңгейлі бағынышты',
      '3-деңгейлі бағынышты',
      '3 күн',
      'Жеткізу бірлігінің бағасы',
      'Сынақ мерзімінің мәліметтері',//24
      'Сынақ нұсқасы: Сатып алудың қажеті жоқ. Ортақ велосипедтерді күніне екі рет орналастырыңыз, әр орналастыру үшін 3 теңге комиссия алынады, барлығы күніне 6 теңге. 2 күндік тегін сынақ нұсқасы.',
      'Тапсырма комиссиясының мысалы:',
      '<p>Күніне 10 000 TJS тұратын көлік тапсырыстарын орындаған 1-деңгейлі серіктестер 300 TJS комиссия алады.</p><p>Күніне 10 000 TJS тұратын көлік тапсырыстарын орындаған 2-деңгейлі серіктестер 200 TJS комиссия алады.</p><p>Күніне 10 000 TJS тұратын көлік тапсырыстарын орындаған 3-деңгейлі серіктестер 100 TJS комиссия алады.</p>',
      'Ұсыныс бонусының сипаттамасы:',
      '<p>(1-деңгейлі бағынышты) Сіз А-ны қосылуға тікелей шақырасыз, А сіздің 1-деңгейлі бағыныштыңыз.</p><p>(2-деңгейлі бағынышты) А В-ны қосылуға шақырады, В сіздің 2-деңгейлі бағыныштыңыз.</p><p>(3-деңгейлі бағынышты) В С-ны қосылуға шақырады, С сіздің 3-деңгейлі бағыныштыңыз.</p><p>Ескертпе: Ұсыным бонусын тек жеке тұлғаның ағымдағы деңгейінің ең жоғары бонусы үшін алуға болады.</p>',
    ]
  },
  charitable: [
    'Жасыл қайырымдылық бастамасы',
    'SGM.s қайырымдылық пен қоғамдық әл-ауқатты корпоративтік миссия деп санайды. Біз үнемі аз қамтылған қауымдастықтарға, мүгедектерге және мектептерге қажетті заттар мен қаражаттарды береміз және үкіметтік емес ұйымдармен жасыл мобильділік және экологиялық жобалар бойынша ынтымақтасамыз',
    'Біз орналастыратын әрбір ортақ велосипед қайырымдылық болып табылады, қалаларға шығарындыларды азайтуға көмектеседі, сонымен қатар жылулық таратады',
    'Біз «велосипед тебу, қайырымдылық және өзара тиімділік» рухын қолдаймыз және дөңгелектерімізбен үміт отын жағамыз. Сіздерді SGM-ге қосылуға, жасыл болашақ үшін жүруге және махаббат таратуға шын жүректен шақырамыз',
    'Біз сіздерді қоғамдық қайырымдылық бастамаларына белсенді қатысуға және бірге қаланың әрбір бұрышында махаббат пен жасылдың гүлденуіне мүмкіндік беруге шақырамыз',
  ],
  lucky: {
    default: [
      "Бақытты педаль",
      "Қалған ұтыс ойындары саны:",
      "Лотерея жазбасы",

      "Лотерея ережелері",

      "<p>Компанияның іс-шараларына қатысып, бақытты ұтыс ойындарына қатысу мүмкіндіктеріне ие болыңыз!</p>",

      "Ұтқан пайдаланушы жазбасы",
      ['Құттықтаймыз:{member}', 'Сыйлықтар {profit} алыңыз'],
      "Құттықтаймыз,Сыйлықтар алыңыз",

      "жабыңыз",

      "Сіздің ұтыс ойындарыңыз аяқталды",

      "Жарамдылық мерзімі"
    ],
    scattered: [
      'Ұтыс саны',
      'Жүру',
      '<p>1. Ұтыс саны компанияның іс-шаралары арқылы алынады!</p><p>2. Әрбір ұтыс ойынына 1 ұтыс жұмсалады!</p><p>3. Физикалық жүлдені ұтып алғаннан кейін, ақпаратыңызды тіркеп, оны алу үшін жалдау менеджеріне хабарласыңыз!</p>',
      'Еске салғыш',
      'Маңызды еске салғыштар',
      'Ұтыс ойынына қатысу құқығы',
      'Компанияның іс-шаралары арқылы ұтыс ойынына қатысу мүмкіндіктерін алыңыз',
      'Ұтыс ойынының ережелері',
      'Әр әрекет үшін 1 ұтыс жұмсалады',
      'Жүлдені пайдалану',
      'Физикалық жүлделер үшін жалдау менеджеріне хабарласыңыз'

    ],
    prizeList: [
      'Lucky Pedal жүлде қоры',
      'TJS52 қолма-қол ақша',
      'Лезде ақша алу',
      'TJS88 қолма-қол ақша',
      'TJS205 қолма-қол ақша',
      'TJS19,889 қолма-қол ақша',

      'TJS236,666 қолма-қол ақша',
      'Android телефоны',
      '8,000 TJS құнында',
      'Жаңарту ваучері',
      '600 TJS құнында',
      'Қос тапсырыстар',

      'Күнделікті',
      'SGM.s компаниясының эксклюзивті қуат банкі',
      '1,000 TJS құнында',

      'Механикалық велосипед',
      '3,000 TJS құнында',
      'Электронды мопед',
      '80,000 TJS құнында',

      'iPhone 17',

      'Құнысында TJS160,000'
    ],
  },
  moments: [
    'Күнделікті жаңартулар',
    'SGM.s қызметкерлеріне велосипедтерді орналастырудан түскен табыс, қайырымдылық шаралары және керемет сәттерімен бөлісуге арналған ресми платформа. Ақшалай сыйлықтар ұтысына (1-200 000 TJS) қатысу үшін күн сайын 3 күн қатарынан жаңартыңыз. Сүйіспеншілікті таратуға және әрбір сапарды құнды етуге командаластарға қосылыңыз.!'
  ],
  userLc: {
    default: [
      "Байлық айналымы",
      "Жазбалар",
      "Сома",
      "Сақтау мерзімі",
      "Салым сомасы",
      "Салым сомасын енгізіңіз",
      "Табыс",

      "Жіберу",//7
      "Алдымен өнімді таңдаңыз",
      "Ақпаратты таңдаңыз",
      "Пайда",
      "Күн",
      "деректер жоқ",
      "Сатып алу уақыты",
      "күй",
      "Аяқталу уақыты",
      "Баланс",
      "Бүгінгі табыс",
      "Бір рет басу арқылы сатып алу"//18
    ],
    tabs: [
      "Өнім тізімі",
      "Үнемдеу жазбасы"
    ],
    tips: '<p>VOISP "Wealth Enhance" - бұл компанияның барлық M-деңгейлі қызметкерлеріне табыстарын арттырудың көбірек жолдарын ұсыну тәсілі. Инвестициялық жобалар - PAGE, банктер, активтерді басқару компаниялары және т.б. бірлесіп іске қосатын қаржылық инвестициялық жобалар!</p><p>Қысқа мерзімді инвестиция: тұрақты табыс, икемді циклді таңдау! Қысқа мерзімді бос тұрған қорлар инвестиция арқылы қосымша табыс әкелуі мүмкін! Ұзақ мерзімді инвестиция: Жоғары кіріс, жақсы тұрақты инвестициялық жинақтарды дамыту, жоғары кіріс алу және жинақтау арқылы армандарыңызды жүзеге асыру!</p>'
  },
  newlist: {
    text: [
      "Ешқандай жазбалар жоқ",
      "Күтілетін табыс",

      "нәтижелер",

      "уақытты сатып алу",

      "мәртебе",

      "Уақыттың аяқталуы"
    ],
    placeholder: [
      "деректер жоқ",
      "деректер жоқ"
    ],
    i18n: [
      "Сатып алу тарихы",
    ],
    title: [
      "Велосипедпен жүру байлығының жасыл жинақ жоспары — SGM.s компаниясының штаттық қызметкерлеріне арналған арнайы жеңілдік!",
      "Сіздің қаражатыңызды жинақ кассалары сияқты қаржы институттары қадағалайды және рұқсат етеді және 100% қауіпсіз және сенімді. SGM.s барлық кезеңдердегі қаржылық мақсаттарыңызға жету үшін икемді шарттармен және әртүрлі кірістермен жинақ өнімдерінің кең таңдауын қамтамасыз ету үшін көптеген жетекші банктермен ынтымақтасады.",
      "Біз сізді велосипедтерді орналастыруға белсенді қатысуға және төмен көміртекті саяхатты қабылдауға шақырамыз, сонымен қатар сіздің жеке қаржыңызды ақылмен жоспарлай отырып, жасыл болашаққа үлес қосасыз деп үміттенеміз. SGM.s жасыл байлықта жаңа тарауды бірге аша отырып, сіздермен бірге жүруге мақтанады!"
    ]
  },
  product: {
    default: [
      "Жарнамалық шоттағы қалдық",
      "Бастапқы жинақ сомасы",

      "Ең жоғары жинақ сомасы",

      "Цикл",

      "Күнделікті пайыздық мөлшерлеме",

      "ең жоғары",

      "Жоба ережелері",

      "Жоба сомасы",

      "Төлем әдісі",

      "Бастапқы жинақ сомасы",

      "Күнделікті пайда",

      "Шығару циклі",

      "Болжамды табыс"
    ],
    placeholder: [
      "Негізгі сома мен кірісті мерзімі өткеннен кейін қайтару (мереке күндері әдетте)",
      ", 24 сағат ішінде автоматты түрде есеп айырысу",
      "{str} = жалпы кіріс {income} {currency} + негізгі {money} {currency} = жалпы негізгі сома мен пайыз {total} {currency}",
      "Қауіпсіздік құпия сөзі"
    ]
  },
  user: {
    vipl: "Серіктес деңгейі",
    hello: "Қайта қош келдіңіз",
    default: [
      "Менің бастығым",
      "Шот",

      "Шақыру коды",

      "Кіруден шығу",

      "Баланс",

      "Алтын",

      "Менің әмияным",

      "Мөр",

      "Шектеу",
      "Жақсы",
      "Керемет",
      "Оқу көмекшісін іске қосу",
      "Жалдау менеджеріне хабарласу",
      "Операциялық шығындар"
    ],
    myEarnings: {
      grid: ["Баланс", "Кешегі табыс", "Бүгінгі табыс", "Осы аптадағы табыс", "Осы айдағы табыс", "Өткен айдағы табыс", "Жалпы табыс", "Бүгінгі тапсырманы орындау (PCE)", "Бүгінгі қалған тапсырмалар (PCE)", "Бүгінгі комиссия", "Жеткізу жеңілдігі", "Жолдама жеңілдігі"]
    },
    grid: [
      "Қалдық",
      "Кешегі табыс",

      "Бүгінгі табыс",

      "Осы аптадағы табыс",

      "Осы айдағы табыс",

      "Өткен айдағы табыс",

      "Жалпы табыс",

      "Бүгінгі тапсырманы орындау (PCE)",

      "Бүгінгі қалған тапсырмалар (PCE)",

      "Бүгінгі комиссия",
      "Бүгінгі жеңілдік"
    ],
    menu: [
      "Тапсырма жазбалары",
      "Аудит тапсырмасы",
      "Шығарылымды басқару",

      "Жеке ақпарат",//3
      "Шотты байланыстыру",
      "Күнделікті есеп",
      "Бухгалтерлік жазбалар",//6
      "Ортақ шақыру",
      "Командалық есептер",//8
      "Анықтамалық нұсқаулық",//9
      "Несиелік балл",//10
      "ҚОСЫМШАНЫ жүктеп алу",//11
      "Бақытты педаль",//12
      "Велосипедпен жүру",
      "Оқу көмекшісі",
      "Корпоративтік мәдениет",
      "Бейне нұсқаулық",
      "Керемет команда",
      "Велосипедпен жүру",
      "SGM.s-ді қадағалаңыз",
      "Өсу сыйақылары",
      "Велосипед кодексі",
      "Іс-әрекет педалі"
    ],
    positions: [
      "Менің лауазымым",
      "Қазіргі лауазым",

      "Келесі лауазым",

      "Тікелей байланысты M-деңгейлі мүше",

      "3-деңгейлі M командасының мүшесі",

      "3-деңгейлі команда ({post} нөмірі)",
      "Лауазымыңызды жоғарылату үшін жалдау менеджерімен байланысу үшін барлық талаптарды орындаңыз!",
      "Лауазымның сипаттамасы",
      "Лауазымға өтініш беру",
      "Лауазым туралы ақпарат"
    ],
    office: [
      "Менің жұмыс туралы ақпаратым",
      "Лауазым бойынша өсу туралы мәліметтер",
      "SGM.s лауазымының сипаттамасы",
      "Корпоративтік лауазым",
      "Лауазым бойынша өсу",
      "атрымліваць",
      "Лауазым бойынша өсу барысы",
      "Кем дегенде ",
      "Шарттар орындалмады",//8
      "Непасрэдныя падначаленыя павінны прадаць {num} ровараў.",
      "Супрацоўнікі каманды павінны прадаць {num} ровараў.",
      " мүшелерден артық болуы керек",
      "Алынды"//12
    ],
    current: [
      "Қазіргі лауазымдар", "VIP мүшелерінің жалпы саны"
    ],
    subordinate: [
      "1-деңгейлі",
      "2-деңгейлі",

      "3-деңгейлі",

      "мүшелер тізімі",
      "барлық адамдар",
      "Жалпы кіріс",
      "Ақша алу сомасы",
      "Команданың табысы",
      "Мүшелер тізімі",
      "пайдаланушы",

      "деңгей",

      "Қосылу уақыты",
      "Сынақ кезеңі"
    ],
    follow: [
      "SGM.s ресми арнасы",
      "SGM.s туралы соңғы ақпарат туралы көбірек білу үшін арнаны бақылаңыз!"
    ]
  },
  userInfo: {
    default: [
      "Жеке ақпарат",
      "Бас портреті",

      "Ұялы телефон нөмірі",

      "Банк шотын қосу",

      "Alipay",

      "Шынайы аты-жөні",

      "Кіру құпия сөзі",

      "Қор құпия сөзі",

      "Параметрлерді басу",
      "Бас портретін өзгерту",
      "Кіру құпия сөзін өзгерту",

      "Қор құпия сөзін өзгерту",

      "Жіберу",

      "Кэшті босату",
      "Шығу"
    ],
    label: [
      "Бастапқы кіру құпия сөзі",
      "Жаңа кіру құпия сөзі",

      "Құпия сөздерді растау",

      "Бастапқы ақша коды",

      "Жаңа ақша коды",

      "Құпия сөзді растау"
    ],
    placeholder: [
      "Бастапқы кіру құпия сөзін енгізіңіз",
      "Жаңа кіру құпия сөзін енгізіңіз",

      "Кіру құпия сөзін растаңыз",

      "Бастапқы қор құпия сөзін енгізіңіз",

      "Жаңа қор құпия сөзін енгізіңіз",

      "Қор құпия сөзін растаңыз"
    ]
  },
  userSet: {
    default: [
      "Шынайы аты-жөніңізді растау",
      "Толық ақпарат",

      "Alipay-ді байланыстыру",

      "Жіберу"
    ],
    label: [
      "Шынайы аты-жөні",
      "QQ",
      "Alipay тіркелгісі",

      "Alipay аты-жөні"
    ],
    placeholder: [
      "Шын атым (менің атым қолма-қол ақша алу үшін қолданылады)",
      "QQ нөмірін енгізіңіз",
      "Alipay шотын енгізіңіз",

      "Alipay атын енгізіңіз"
    ],
    tips: "Ескерту: Байланған банк картасын өзгерту мүмкін емес, ол сіздің ақша алуыңыз үшін қолданылады"
  },
  bindAccount: {
    default: [
      "Тіркелгіні байланыстыру",
      "Оқулықты қарау",

      "Жіберу"
    ],
    tabs: [
      "Тіркелгі",
      "Тіркелгі",
      "Тіркелгі"
    ],
    label: [
      "Нұсқаулар",
      "Скриншот қосу",

      "Тіркелгі"
    ],
    placeholder: "{account} тіркелгіңізді енгізіңіз"
  },
  bankCard: {
    default: [
      "Банк картасын байлау",
      "Қазір аутентификациялау",
      "Жіберілуде ...",
      "Қазір қосу",
      "Банк картасын қосу"
    ],
    tips: [
      "Банк картасын қоспас бұрын нақты аты-жөніңізді растауды аяқтаңыз",
      "Банк картаңыздағы шот атауы сіз растаған нақты аты-жөніңізге сәйкес келуі керек, әйтпесе қолма-қол ақшаны сәтті ала алмайсыз."
    ],
    label: [
      "Аты-жөні",
      "Банк атауы",

      "Банк шотының нөмірі",

      "Филиал коды",

      "IFSC"
    ],
    placeholder: [
      "Банк атауын таңдаңыз",
      "Банк шотының нөмірін енгізіңіз",

      "Филиал кодын енгізіңіз",

      "Растау",
      "Бас тарту",

      "IFSC енгізіңіз"
    ]
  },
  wallet: {
    default: [
      "Менің әмияным",
      "Қайта толтыру",
      "Шығару",

      "Қайта толтыру жазбасы",
      "Шығару жазбасы",
      "R",
      "W",
      "₽ қайта толтыру"
    ],
    label: [
      "Ақша алу әдісі",
      "Ақша алу сомасы",

      "Қор құпия сөзі",

      "Жіберу",

      "Телефон нөмірі",

      "Электрондық пошта",

      "IFSC",

      "Төлем әдісі",

      "Салық салу",

      "Алынған нақты сома"
    ],
    placeholder: [
      "Ақша алу әдісін таңдаңыз",
      "Ақша алу сомасын енгізіңіз",

      "Қор құпия сөзін енгізіңіз",

      "Ақша алу әдісін таңдаңыз",

      "Алушының ұялы телефон нөмірін енгізіңіз",

      "Алушының электрондық пошта мекенжайын енгізіңіз",

      "Алушының IFSC мекенжайын енгізіңіз",

      "Төлем әдісін таңдаңыз"
    ],
    msg: [
      "Сіз әлі қор құпия сөзін орнатқан жоқсыз, алдымен біреуін орнатыңыз",
      "Сіз әлі банк картаңызды байланыстырған жоқсыз, алдымен оны байланыстырыңыз",
      "<p>Ақшаны алу уақыты:</p><p>Дүйсенбі: M9</p><p>Сейсенбі: M8</p><p>Сәрсенбі: M6/M7</p><p>Бейсенбі: M3/M4/M5</p><p>Жұма: M1/M2</p><p>(Дүйсенбіден жексенбіге дейін тағылымдамадан өтушілер)</p><p>Сағат 9:00-ден 18:00-ге дейін</p>"
    ]
  },
  recharge: {
    default: [
      "Қайта толтыру",
      "Қайта толтыру мәліметтері",

      "Қайта толтыру жазбасы",

      "Қолжетімді баланс {money}, қайта толтыру әдісін таңдаңыз",

      "Бір минималды сома {currency} {min}, максималды {currency} {max}, өңдеу комиссиясы {fee}%",

      "Жіберілуде...",
      "Қазір қайта толтыру",
      "Қайтару",

      "Жүктелуде...",

      "Бір минималды сома ${min}, максималды ${max}, өңдеу комиссиясы {fee}%"
    ],
    label: [
      "Қайта толтыру сомасы",
      "Қайта толтыру арнасы",
      "Аударымның атауы",
      "Төлеушінің аты-жөні",
      "Төлеушінің ұялы телефоны",
      "Төлеушінің UPI шоты",
      "Төлеушінің электрондық поштасы",
      "Транзакция тапсырысы"
    ],
    placeholder: [
      "Қайта толтыру сомасын енгізіңіз",
      "Қайта толтыру арнасын таңдаңыз",

      "Аударымның атауын енгізіңіз",

      "Ең аз сома - {currency} {min}",
      "Ең көп сома - {currency} {max}",

      "Төлеушінің атын енгізіңіз",

      "Төлеушінің ұялы телефон нөмірін енгізіңіз",
      "Төлеушінің UPI тіркелгісін енгізіңіз",
      "Төлеушінің электрондық пошта мекенжайын енгізіңіз",

      "Аударымның скриншотын жүктеңіз",
      "Транзакция тапсырысының нөмірін енгізіңіз"
    ],
    info: [
      "Қайта толтыру сомасы",
      "Тапсырыс нөмірі",
      "Банк",

      "Шот нөмірі",

      "Аты-жөні",

      "Көшіру",

      "{type} Аудару",

      "Аударудың скриншоты",
      "Жіберу",

      "IFSC коды",

      "Шот түрі",

      "Өңдеу нұсқаулары"
    ],
    tips: [
      "Қаржылық чектегі кідірістерді болдырмау үшін сәйкес келетін соманы аудару үшін келесі әдісті таңдаңыз.<br>Аударудан кейін аударым скриншотын растау сертификаты ретінде жүктеңіз",
      "Достар қосудың қажеті жоқ, маған ақша аудару үшін QR кодын сканерлеңіз",

      "Төмендегі ақпаратқа сәйкес аударымды аяқтаңыз",

      "Кеңес: Төлем сәтті аяқталғаннан кейін, қаржы бөліміне уақытында қаражат қосуға ыңғайлы мүше шот нөміріңізді, қайта толтыру сомасын, тапсырыс нөмірін, салымшы шот нөмірін, қайта толтыру уақытын беру үшін онлайн қызметке хабарласыңыз.",
      "Ескерту: әрбір аударым үшін бір төлем жасаңыз",

      "Аударымнан кейін аударым скриншотын растау сертификаты ретінде жүктеңіз",
      "Кеңес: Төлем сәтті аяқталғаннан кейін, сәтті транзакцияның суретін жүктеңіз",
      "<p>Қайта толтыру туралы еске салу: Қайта толтырмас бұрын оқып шығыңыз.</p><p>1: Соңғы қайта толтыру шотына сәйкес төлеңіз.</p><p>2: Төлемнің жарамдылық мерзімі - 10 минут. Төлемді 10 минут ішінде аяқтаңыз. Егер төлем 10 минуттан кейін жасалмаса, алушы шот жарамсыз болады. Соңғы қайта толтыруды қайта алыңыз. төлемге арналған шот.</p><p>3: Аударым сомасы сіз жіберген сомамен сәйкес келуі керек.</p><p>4: Егер төлем сәтсіз аяқталса, алдыңғы алушы шотты сақтамаңыз. Соңғы шотты алу үшін қайта толтыру тапсырысын қайта жіберіңіз, әйтпесе төлеміңіз жарамсыз болып саналады.</p><p>5: Егер төлем сәтті болса, қаржы бөлімінің уақтылы тексеруін жеңілдету үшін қажетінше Плацежны чэк жіберіңіз.</p>"
    ]
  },
  postTask: [
    "тақырып",
    "Суретті таңдау",

    "Жеткізу",

    "Тапсырмаға тақырып енгізіңіз"
  ],
  task: {
    default: [
      "Жеткізу тізімі",
      "Тапсырма талаптары",
      "Жасау",

      "Аудит",

      "Сілтемені ашу",

      "Сілтемені көшіру",

      "Бірлік бағасы",

      "Жіберу",

      "Бас тарту",

      "Қызмет көрсетуді бастау",

      "Орындалуда",
      "ОРНАЛАСТЫРУДЫ БАСТАУ"
    ],
    tabs: [
      "Орындалуда",
      "Аудит",

      "Аяқталды",

      "Сәтсіз аяқталды",

      "Зұлым ниет",

      "Тасталған"
    ],
    msg: "Бүгінгі миссия аяқталды",
    msgSc: "Сәтті алынды",
    msgTime: "Кері санақ аяқталғаннан кейін, тапсырма автоматты түрде орындалады және оны ерте жабу жарамсыз болады!",
    info: [
      "Тапсырманың мәліметтері",
      "Тапсырма атауы",
      "Тапсырманың артықшылықтары",
      "Тапсырманың сипаттамасы",
      "Талаптарды жүктеу",
      "Үлгі жіберу",
      "Пайдаланушы үлгіні жібермеді",
      "Аудит жазбалары",
      "Аудит күні",
      "Сұраныс жағы",
      "Шығару",
      "Көшіру",
      "Секіру",

      "Тапсырма қадамдары",
      "Қадам {index}",
      "Аудит үлгісі",
      "Аудит үлгісі жоқ",
      "Деректер жүктелуде...",
      "Тапсырмадан бас тарту",
      "Аяқталған тапсырманы жіберу",
      "Мазмұнды жариялау"
    ],
    index: [
      "Ағымдағы мәртебе",
      "Сіздің ағымдағы бағаңыз <i style=\"color:#1989fa\">{currVip}</i><br>тек ағымдағы <i style=\"color:#1989fa\">{currVip}</i> деңгейлі тапсырманы талап ете алады<br>сіз <i style=\"color:#dd6161\">{vip}</i> деңгейіне қосылғыңыз келе ме?",
      "Қазір қосылыңыз",
      "Тапсырма санатын таңдаңыз",
      "Бас тарту",
      "Қалған",
      "Тегін жеткізу",
      "Әзірлену үстінде"
    ],
    list: [
      "Тапсырмалар тізімі",
      "Сұраныс жағы",

      "Қалған",

      "Сұраныс",

      "Қабылдаушы"
    ],
    show: [
      "Тапсырма мәліметтері",
      "Сатып алу уақыты",

      "Жеткізу мәртебесі",

      "Жалға алу бағасы",

      "Жеткізу уақыты",

      "Алуға дейінгі кері санақ",
      "Қызмет көрсетуді бастау",

      "Кодтау",
      "ЖОҚ"
    ]
  },
  postRecord: [
    "Күнделікті жаңартулар",
    "Шығарылым",
    "Барлығы",
    "Аяқталды",

    "Мерзімі",

    "Аудит",

    "Жою",

    "Редакторлар",

    "Күнделікті жаңартулар",
    "Қабылдау",

    "SGM.s хабарландыру орталығы",
    "Ақпарат орталығы"
  ],
  dayReport: [
    "Күнделікті есеп",
    "Жалпы кіріс",

    "Менің комиссиям",

    "Менің комиссиялық сыйақым",

    "Бағыныштылар орындаған жеткізу",
    "Бағыныштылардың тапсырмаларының жеңілдіктері",
    "PCE",

    "Соңғы 30 күн",

    "Саны",

    "Жеткізу",

    "Бағынышты",

    "Тұтыну",

    "Күні"
  ],
  fundRecord: {
    default: [
      "Шығындар туралы жазбалар",
      "Қайта толтыру туралы жазба",
      "Табыс туралы жазбалар",
      "R",
      "I",
      "E",
      "Алынған қаражат туралы жазбалар",
    ],
    tabs: [
      "Табыс",
      "Шығындар",

      "Қайта толтыру",

      "Ақша алу"
    ],
    state: [
      'Барлығы',
      'Қайта зарядтау',	//1 recharge
      'Ақшаны алу',	//2 withdrawal
      'Тапсырманы жариялау',	//3 task
      'Платиналық сорғы',	//4 pump
      'Жеңілдік',	//5 rebate
      'Жеткізу аяқталды',	//6 commission
      'Белсенділік сыйақылары',	//7 regment
      'Ұсыныс бойынша марапаттар',	//8 spread
      'Жаңарту',	//9 buymembers
      'Тапсырманы болдырмау',	//10 revoke
      'Инвестициялық табыс',	//11 transfer_c
      'Инвестицияға аудару',	//12 transfer_r
      'Басқа кірістер', //13 其他
      'Қайырымдылық жасау',	//14
      'Қызыл конверт',	//15
      'Ақылды роботтарды сатып алыңыз',//16
      'Бақытты педаль',//17
      'VIP сатып алуды қайтару',//18
    ]
  },
  promote: [
    "Сіздің ең жақын досыңыз",
    "Сізді {title}-ге қосылуға шақырамын",
    "Ұсыныс коды",
    "Ұсыныс кодын көшіру",

    "Шақыру сілтемесін көшіру",

    "QR кодын сақтау",
    "Жарнамалық ынталандырулар",

    "Постерді сәтті сақтау",//7
    "Постерді сақтау мүмкін болмады, тағы бірнеше рет көріңіз немесе скриншот сақтаңыз",
    "Скриншот жасаңыз",

    "Жарнамалық плакатты сақтау",
    "Жарнамалық плакатты телефоныңызға сақтаңыз<br>Егер сәтсіз болсаңыз, тағы бірнеше рет көріңіз немесе скриншот сақтаңыз",
    "Тек ресми SGM.s серіктестері достарды қосылуға шақыра алады!",
    "Ортақ шақыру",
    '<p>1. Ортақ бонус: Жаңа пайдаланушыларды ортақ бонус алу үшін SGM.s-ге шақырыңыз.</p><p>2. Команда комиссиясы: Сіз күн сайын бағыныштыларыңыздың велосипед операцияларынан комиссия ала аласыз.</p><p>3. Компания іс-шаралары: Компания мезгіл-мезгіл әртүрлі акцияларды, соның ішінде "Бақытты педаль", "Велосипед коды" және физикалық сыйлықтарды іске қосады.</p><p>4. Жинақталған сыйақылар: Платформаның басты бетінде белгілі бір сандағы достарыңызды арнайы ақшалай сыйақы алуға шақырыңыз. Неғұрлым көп шақырсаңыз, сыйақы соғұрлым жоғары болады.</p><p>5. Компаниядағы лауазымдар: Командаңыз белгілі бір мөлшерге жеткеннен кейін, сіз компания ішіндегі бастапқы, орта, аға және маркетинг менеджері лауазымдары сияқты басқа лауазымдарға өтініш бере аласыз және қосымша айлық жалақы ала аласыз.</p><p style=\"font-weight: bolder\">Әрбір велосипедті пайдалану қаржылық еркіндікке қарай қадам болып табылады; әрбір сапар қалалық шығарындыларды азайтуға ықпал етеді. SGM сізге қаржылық еркіндікке де, жасыл өмір салтына да қол жеткізуге көмектеседі.</p>',
    "Командамен бірге саяхаттау"
  ],
  teamReport: {
    default: [
      "Іздеу",
      "Команда балансы",
      "Команда жеңілдіктері",
      "Команданы қайта толтыру",
      "Командадан шығу",
      "Бірінші төлем саны",
      "Бірінші шақыру саны",

      "Команда мөлшері",
      "Жаңа команда",
      "PCE",
      "Мен",
      "Пайдаланушы",
      "Қайта толтыру",
      "Алынған қаражат",
      "Жеңілдік",

      "Комиссия",

      "Күнді таңдаңыз",

      "Деректер жоқ",
      "Алынған қаражат сомасы",
      "Алынған қаражат саны",
      "Алынған қаражат қайтарымы",

      "Командадан алынған қаражат саны",//21
      "Команда серіктесі",
      "Ұсынылған жалпы табыс",
      "Жеткізу жеңілдіктерінен түскен жалпы табыс",
      "3-деңгейлі команданың жалпы қаражат алуы",
      "Баға",
      "Ата-ана",
      "Шақырылғандар",
      "Пайдаланушылар тізімі",
      "Жалпы пайдаланушы"
    ],
    tabs: [
      "Команда есептері", "Менің командам"
    ],
    team: [
      "Деңгей 1",
      "Деңгей 2",
      "Деңгей 3"
    ]
  },
  help: [
    "Анықтамалық нұсқаулық",
    "Қолжетімді емес"
  ],
  message: [
    "Хабарламаны қарау",
    "Хабарлама жоқ"
  ],
  credit: [
    "Несиелік балл",
    "Несиелік жазба",
    "Несиелік жазбалар",
    "<p>Бастапқы несиелік балл 60 ұпай.</p><p>1: Егер ұпайлар 50-ден аз болса, күнделікті жеткізу көлемі екі есеге азаяды.</p><p>2: Ұпай 30 ұпайдан аз және күнделікті жеткізу жұмыстарын аяқтау мүмкін емес.</p><p>3: Егер ұпай 10 ұпайдан аз болса, қолма-қол ақша алуға өтініш бере алмайсыз.</p><p>Ұпайлық марапаттау ережелері: Жұмыс деңгейін көтеру 5 ұпай қосады, ал бағыныштыларды (ресми қызметкерлер) болуға шақыру 1 ұпай қосады.</p><p>Жұмысқа теріс көзқарас, жеткізуді уақытында аяқтамау және компания ережелерін бұзу несиелік рейтингке әсер етеді.</p>",
    "Менің несием",
    "Қазіргі уақытта несиелік тарих жоқ"
  ],
  dialog: [
    "Кеңестер",
    "Растау",

    "Жіберілуде...",

    "Көшіру сәтті аяқталды",

    "IOS жүйесінің нұсқасы төмен және қолдау көрсетілмейді",

    "Тіркелуде...",

    "Деректер жүктелуде..."
  ],
  lineList: [
    "Жолды таңдау",
    "Ағымдағы жол",
    "Жол"
  ],
  serviceCenter: [
    "Клиенттерге қызмет көрсету",
    "Сәлеметсіз бе, эксклюзивті клиенттерге қызмет көрсету",

    "Сізге қызмет көрсетуге қуаныштымын.",

    "Өзіне-өзі қызмет көрсету",

    "Онлайн клиенттерге қызмет көрсету",

    "Клиенттерге қызмет көрсетуді қайта толтыру",

    "Желілік клиенттерге қызмет көрсету"
  ],
  direct: [
    'SGM.s',
    'Өсу бонусы',

    'Әрекет сипаттамасы',
    '<p>Мүшелерді VIP деңгейіне қосылуға тікелей шақырғаннан кейін, шарттарды орындасаңыз, ақшалай сыйақы ала аласыз!</p><p>Мысалы: егер сіз VIP деңгейіндегі 3 мүшені жиынтық түрде шақырсаңыз, сыйақыны тікелей ала аласыз. Оны алғаннан кейін, басқа мақсаттарға жетуді жалғастырыңыз және оны алуды жалғастырыңыз.</p><p>SGM.s эксклюзивті өсу сыйақысы, әрбір сыйақыны әрбір қызметкер тек бір рет ала алады.</p>',
    'Бағыныштылар саны',
    'Аяқталуы керек',
    'Шақыру жеңілдіктері',
    'Сыйақы алу',

    'Алынған'
  ],
  activity: [
    'Қайырымдылық педалі',
    'Мәліметтер',
    'Қайырымдылық жасау',
    'Шот қалдығы',

    'Барлығы',

    'Төлем',
    'Қайырымдылық сомасын енгізіңіз',

    'Қайырымдылығыңыз үшін рақмет'
  ],
  apply: {
    awardsTitle: "Awards",
    awardsContent: "Awards",
    pickUpVehicles: "{count} көлікті алу"
  },
  positions: {
    info: ['Лауазымның мәліметтері', 'Лауазымға өтініш', 'Лауазым', '3-деңгейлі команда G-деңгейлі тұрақты қызметкерлер', 'Үшінші деңгейдегі команда мүшелерінің арақатынасы', 'Осы айдағы жалақы', 'Жалақыны есептеу', 'Аяқталған', 'Аяқталуы тиіс', 'Алынған', 'Жалақы жинау уақыты'],
    job: ['Қарап шығу үшін жіберу', 'Қаралып жатыр', 'Қарастырылды', 'Тиісті құжаттарыңызды жүктеңіз', 'Түсініктемелер', 'Жеке куәлігіңіздің фотосуретін таңдау және жүктеу үшін суретті басыңыз. ', 'Жеке куәлігіңіздің алдыңғы жағының суретін А фотосуретіне жүктеңіз. ', 'Жеке куәлігіңіздің артқы жағының суретін B фотосуретіне жүктеңіз. ', 'C фотосуретінде жеке куәлігіңізді ұстап тұрған суретіңізді жүктеңіз. ', 'А фотосуреті', 'B фотосуреті', 'C фотосуреті', 'Көтергіңіз келетін лауазымды таңдаңыз', 'Лауазым', 'Негізгі жалақы', 'Қосымша бонус', 'Қызметкерлерге арналған хабарлама', 'Мен «Лауазымға өтініш беру жөніндегі нұсқаулықтың» мазмұнымен таныстым және келісемін', 'Лауазымға өтініш беру', "Лауазым таңдаңыз", "А фотосуретін таңдаңыз", "B фотосуретін таңдаңыз", "C фотосуретін таңдаңыз"]
  },
}